const chains = {
  250: {
    name: 'fantom',
    displayName: 'Fantom',
    symbol: 'FTM',
    wrapped: 'WFTM',
    stableCoin: 'DAI',
    explorer: 'https://ftmscan.com',
    url: 'https://rpc.ftm.tools',
    chainId: 250,
    lzEndpoint: '0xb6319cC6c8c27A8F5dAF0dD3DF91EA35C4720dd7',
    lzChainId: 12
  },
  43114: {
    name: 'avalanche',
    displayName: 'Avalanche',
    symbol: 'AVAX',
    wrapped: 'WAVAX',
    stableCoin: 'MIM',
    explorer: 'https://snowtrace.io',
    url: 'https://api.avax.network/ext/bc/C/rpc',
    chainId: 43114,
    lzEndpoint: '0x3c2269811836af69497E5F486A85D7316753cf62',
    lzChainId: 6
  },
  43113: {
    name: 'fuji',
    displayName: 'Avalanche Fuji',
    symbol: 'AVAX',
    wrapped: 'WAVAX',
    stableCoin: 'MIM',
    explorer: 'https://testnet.snowtrace.io',
    url: 'https://api.avax-test.network/ext/bc/C/rpc',
    chainId: 43113,
    lzEndpoint: '0x93f54D755A063cE7bB9e6Ac47Eccc8e33411d706',
    lzChainId: 10006
  },
  1: {
    name: 'ethereum',
    displayName: 'Ethereum Mainnet',
    symbol: 'ETH',
    wrapped: 'WETH',
    stableCoin: 'USDT',
    explorer: 'https://etherscan.io',
    url: 'https://mainnet.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
    chainId: 1,
    lzEndpoint: '0x66A71Dcef29A0fFBDBE3c6a460a3B5BC225Cd675',
    lzChainId: 1
  },
  3: {
    name: 'ropsten',
    displayName: 'Ethereum Ropsten',
    symbol: 'ETH',
    wrapped: 'WETH',
    stableCoin: 'USDT',
    explorer: 'https://ropsten.etherscan.io',
    url: 'https://ropsten.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
    chainId: 3
  },
  4: {
    name: 'rinkeby',
    displayName: 'Ethereum Rinkeby',
    symbol: 'ETH',
    wrapped: 'WETH',
    stableCoin: 'USDT',
    explorer: 'https://rinkeby.etherscan.io',
    url: 'https://rinkeby.infura.io/v3/9aa3d95b3bc440fa88ea12eaa4456161',
    chainId: 4,
    lzEndpoint: '0x79a63d6d8BBD5c6dfc774dA79bCcD948EAcb53FA',
    lzChainId: 10001
  },
  137: {
    name: 'polygon',
    displayName: 'Polygon',
    symbol: 'MATIC',
    wrapped: 'WMATIC',
    stableCoin: 'DAI',
    explorer: 'https://polygonscan.com',
    url: 'https://polygon-rpc.com',
    chainId: 137,
    lzEndpoint: '0x3c2269811836af69497E5F486A85D7316753cf62',
    lzChainId: 9
  },
  56: {
    name: 'bsc',
    displayName: 'Binance Smart Chain',
    symbol: 'BNB',
    wrapped: 'WBNB',
    stableCoin: 'BUSD',
    explorer: 'https://bscscan.com',
    url: 'https://bsc-dataseed.binance.org',
    chainId: 56,
    lzEndpoint: '0x3c2269811836af69497E5F486A85D7316753cf62',
    lzChainId: 2
  },
  97: {
    name: 'bscTestnet',
    displayName: 'BSC Testnet',
    symbol: 'BNB',
    wrapped: 'WBNB',
    stableCoin: 'BUSD',
    explorer: 'https://testnet.bscscan.com',
    url: 'https://data-seed-prebsc-1-s1.binance.org:8545',
    chainId: 97,
    lzEndpoint: '0x6Fcb97553D41516Cb228ac03FdC8B9a0a9df04A1'
  },
  42161: {
    name: 'arbitrum',
    displayName: 'Arbitrum',
    symbol: 'ETH',
    wrapped: 'WETH',
    stableCoin: 'USDC',
    explorer: 'https://arbiscan.io',
    url: 'https://arb1.arbitrum.io/rpc',
    chainId: 42161,
    lzEndpoint: '0x3c2269811836af69497E5F486A85D7316753cf62',
    lzChainId: 10
  },
  10: {
    name: 'optimism',
    displayName: 'Optimism',
    symbol: 'ETH',
    wrapped: 'WETH',
    stableCoin: 'USDC',
    explorer: 'https://optimistic.etherscan.io',
    url: 'https://mainnet.optimism.io',
    chainId: 10,
    lzEndpoint: '0x3c2269811836af69497E5F486A85D7316753cf62',
    lzChainId: 11
  }
};

export default chains;
